'use strict';

$(function() {
  $('.key-slider').on('init', function(event, slick) {
    $(this).append('<div class="key-slider__counter"><span class="current"></span> / <span class="total"></span></div>');
    $('.current').text(slick.currentSlide + 1);
    $('.total').text(slick.slideCount);
  })
  .slick({
    autoplay:true,
    autoplaySpeed:3000,
    dots:true,
    arrows: true,
    slidesToShow:1,
    slidesToScroll:1,
    prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="top-slide__prev"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg>',
    nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="top-slide__next"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg>',
    dotsClass: 'key-slider__dots',
    responsive: [
    {
      breakpoint: 768,
      settings: {
      arrows: false
      },
    },
  ]
  })
  .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.current').text(nextSlide + 1);
  });
});

// FAQ用
$(function () {
  $('.faq__list--each').on('click', function () {
    $(this).toggleClass('faq-open');
    $(this).children('.faq__list--answer').slideToggle();
  });

  $('.details-open').hover(function() {
    $(this).attr('open');
  });
});

// 言語セレクター
$(function() {

  const currentURL = location.href;
  const langValue = ['','en','zh-cn','zh-tw'];
  const langText = ['日本語','English','简体中文','繁體中文'];

  const splitURL = currentURL.split('.com/');
  const domaine = splitURL[0];
  let lastURL = splitURL[1];

  // 最初の２文字取得して言語フィルターかかってたら削除
  let firstTwo = splitURL[1].slice(0,2);
  if (firstTwo == 'zh') {
    firstTwo = splitURL[1].slice(0,5);
  }

  let thisLocation = '';
  if (firstTwo ==  langValue[1]) {
    lastURL = lastURL.slice(3);
  } else if (firstTwo ==  langValue[2] || langValue[3]) {
    lastURL = lastURL.slice(6);
  }

  console.log(lastURL);

  // selectされてる言語を判定
  for (let l = 0; l < langValue.length; l++) {
    if (firstTwo == langValue[l]) {
      thisLocation = langValue[l];
    }
  }

  console.log(domaine);

  let redirectURL;
  let option;

// PC版用のオプション追加
  for(let i = 0; i < langValue.length; i++) {
    addOption(i);
    $('#lang-selector-pc').append(option);
  }

// SP版用のオプション追加
  for(let i = 0; i < langValue.length; i++) {
    addOption(i);
    $('#lang-selector-sp').append(option);
  }

  function addOption(i) {
    redirectURL = domaine + '.com/' + langValue[i] + '/' + lastURL;
    redirectURL = redirectURL.replace('.com//', `.com/`);
    if (firstTwo == langValue[i]) {
      option = $('<option>')
      .val(redirectURL)
      .text(langText[i])
      .prop('selected', true);
    } else {
      option = $('<option>')
      .val(redirectURL)
      .text(langText[i]);
    }
  }

});

// トップに戻るボタン
$(function(){
      var topBtn = $('#page-top');
      topBtn.hide();

      $(window).scroll(function () {
          var w = $(window).width();
          if ($(this).scrollTop() > 200) {
              topBtn.fadeIn();
          } else {
              topBtn.fadeOut();
          }
      });

      topBtn.click(function () {
          $('body,html').animate({
              scrollTop: 0
          }, 500);
          return false;
      });
  });